<div class="footer">
  <div class="rows-count">
    <app-select
      #no_of_items
      [defaultOption]="tableContext.pageSize.toString()"
      [options]="['10', '20', '50', '100']"
      [disableSearch]="true"
      (getSelectedOption)="handleChangePageSize($event.value)"
      size="sm"
    ></app-select>
    <p>{{ dictionaryService.get('itemsPerPage') }}</p>
  </div>

  <div class="pagination">
    {{ tableContext.pages() ? tableContext.pages() : '' }}
    {{
      !tableContext.pages()
        ? dictionaryService.get('noPages')
        : tableContext.pages() > 1
        ? dictionaryService.get('pages')
        : dictionaryService.get('page')
    }}
    <div class="arrows">
      <button
        (click)="language === 'ar' ? setPage('forward') : setPage('backward')"
        [disabled]="
          language === 'ar'
            ? tableContext.page() >= tableContext.pages()
            : tableContext.page() === 1
        "
      >
        <ng-icon name="NavArrowLeft" size="25" strokeWidth="2"></ng-icon>
      </button>

      <div class="current-page">{{ tableContext.page() }}</div>

      <button
        (click)="language === 'ar' ? setPage('backward') : setPage('forward')"
        [disabled]="
          language === 'ar'
            ? tableContext.page() === 1
            : tableContext.page() >= tableContext.pages()
        "
      >
        <ng-icon name="NavArrowRight" size="25" strokeWidth="2"></ng-icon>
      </button>
    </div>
  </div>
</div>
